import { Component, Input, ChangeDetectorRef, ComponentFactoryResolver } from '@angular/core';
import { UserWizardComponent } from '../user.wizard';
import { ActivatedRoute } from '@angular/router';
import { AddUserComponent } from './add.user.component';
import { UserResultsComponent } from '../user-results/user-results.component';
import { AddUserWizardService } from './add-user-wizard.service';
import { ValuesExchangeProvider } from '@nrwl/common-lib';
import { AddUserFusionComponent } from './add.user.fusion.component';
import { AddUserFusionSsoComponent } from './add.user.fusion.sso.component';
@Component({
  selector: 'user-wizard',
  providers: [AddUserWizardService],
  templateUrl: '../../../wizard.template.html',
  styleUrls: [
    '../../../wizard.component.style.scss',
    '../wizard.user.style.scss',
    '../../../wizard.button.style.scss'
  ]
})
export class AddUserWizardComponent extends UserWizardComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;

  constructor(
    wizardService: AddUserWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider
  ) {
    super(wizardService, changeDetectorRef, activatedRoute, factoryResolver);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getWizardService(): any {
    return this.wizardService;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolveComponentType(pageId: string): any {
    switch (pageId) {
      case 'add.user.html':
        this.exchange.notifyListeners('user-profile-role-group-update-done', false);
        return AddUserComponent;
      case 'user-results.component.html':
        return UserResultsComponent;
      case 'add.user.fusion.html':
        this.exchange.notifyListeners('user-profile-role-group-update-done', false);
        return AddUserFusionComponent;
      case 'add.user.fusion.sso.html':
        this.exchange.notifyListeners('user-profile-role-group-update-done', false);
        return AddUserFusionSsoComponent;
      default:
        console.error('Unrecognized template name:', pageId);
        return null;
    }
  }

  toggleFinish(): void {
    const result = this.wizardService.onFinish();
    result.subscribe(() => {
      this.createContentComponent();
      this.exchange.notifyListeners('user-profile-role-group-update-done', true);
    });
  }
}
